import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { LeadershipPage } from './pages/LeadershipPage';
import { GlobalNetworkPage } from './pages/GlobalNetworkPage';
import { ContactPage } from './pages/ContactPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-2">
        <Header data-id="element-3" />
        <main className="flex-1" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/services" element={<ServicesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/leadership" element={<LeadershipPage data-id="element-13" />} data-id="element-12" />
            <Route path="/global-network" element={<GlobalNetworkPage data-id="element-15" />} data-id="element-14" />
            <Route path="/contact" element={<ContactPage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <Footer data-id="element-18" />
      </div>
    </BrowserRouter>;
}